import { ActionTypes } from 'redux/utils/Details'

export default ActionTypes('SEND_SDOH_REPORT')